export default {
  records: {
    loading: '加載中…',
    loadMore: '加載更多',
    empty: '該時段暫無相關領取記錄',
    footer: '僅展示近 7 天領取記錄',

    filterCategory: '類型',
    filterTime: '時間',

    category: {
      all: '全部',
      promotions: '優惠',
      tasks: '任務',
      vipSalary: 'VIP俸祿',
      rakeback: '實時返水',
      referral: '推薦返傭',
    },

    module: {
      promotions: '優惠活動',
      tasks: '獎勵任務',
      vipSalary: 'VIP俸祿',
      rakeback: '實時返水',
    },

    vipType: {
      DAILY: '日俸祿',
      WEEKLY: '周俸祿',
      MONTHLY: '月俸祿',
      UPGRADE: '晉級獎勵',
    },

    vipSalaryDefault: '俸祿',
    taskLevel: '{title} · 第{stage}關',
    rakebackTitle: '實時返水 · {name}',
    rakebackDefault: '實時返水',
  },

  rebate: {
    historyTotal: '歷史總領',
    rulesLabel: '規則說明',
    claimableLabel: '當前可領返水',
    claimNow: '立即領取 {amount}',
    claimed: '已領取 ✓',
    nextPayout: '⏳ {countdown} 後即將派發',
    claimSucceeded: '已領取返水 {amount}',
    claimPending: '返水領取成功，獎勵發放中 {amount}',
    claimFailed: '領取失敗，請稍後重試',
    validBet: '有效投注 {amount}',
    currentRate: '當前比例 {rate}%',
    rulesTitle: '返水規則',
    rateDetailTitle: '返水比例詳情',
    filterGameType: '遊戲類型',
    filterVendor: '廠商',
    baseMatrix: '基礎矩陣',
    vipLevel: 'VIP 等級',
    totalDeposit: '累計充值',
    rebateRate: '返水比例',
    loading: '加載中…',
    rateNote: '返水比例隨 VIP 等級提升，以上為當前廠商各等級實時返水比例，升級後即時生效。',
    ruleRatioTitle: '返水比例',
    ruleRatio1:
      '按<b>有效投注額</b>實時計算返水，比例隨遊戲類型與廠商浮動：電子最高 <b>1.0%</b>、捕魚最高 <b>0.7%</b>、真人最高 <b>0.6%</b>、棋牌最高 <b>0.5%</b>、體育最高 <b>0.38%</b>。',
    ruleRatio2: 'VIP 等級越高，返水比例越高，具體以「實時返水」頁各廠商顯示的當前比例為準。',
    ruleDistributeTitle: '派發規則',
    ruleDistribute1: '產生有效投注後<b>實時派發 50%</b>，可立即領取。',
    ruleDistribute2: '剩餘 50% 每 <b>2 小時派發 12.5%</b>，共 8 次派發完畢。',
    ruleDistribute3: '返水<b>無上限</b>，投注越多返得越多。',
    ruleClaimTitle: '結算與領取',
    ruleClaim1: '有效投注實時累計，每日 00:00{note} 清算上一自然日數據。',
    ruleClaim2: '返水在「獎勵中心 · 實時返水」<b>手動領取</b>，未領取的返水將持續累計，不會過期。',
    ruleClaim3: '領取的返水需完成 <b>{n} 倍流水</b>後方可提現。',
    ruleClaimFree: '領取的返水<b>免碼</b>，直接進入可用餘額。',
    ruleClaim4: '對沖、刷單等無效投注不計返水。',
    all: '全部',
    gameType: {
      original: '綜合',
      slots: '電子',
      card: '棋牌',
      live: '真人',
      lottery: '彩票',
      fish: '捕魚',
      sport: '體育',
      esport: '電競',
    },
  },

  vip: {
    loading: '加載中...',
    loadError: '加載失敗，請稍後重試',
    retry: '重試',
    claimReceived: '{label}{amount} 已入賬餘額',
    claimProcessing: '{label}{amount} 領取成功，獎勵發放中',

    cardType: {
      UPGRADE: '晉級彩金',
      DAILY: '日俸祿',
      WEEKLY: '周俸祿',
      MONTHLY: '月俸祿',
    },

    action: {
      AVAILABLE: '領取',
      /** 已點領取、錢包還沒落定；與優惠活動 CLAIM_PROCESSING 同文案 */
      PROCESSING: '發放中',
      CLAIMED: '已領取 ✓',
      EXPIRED: '已過期',
      LOCKED_WITH_DATE: '{date} 可領',
      LOCKED_COUNTDOWN: '{countdown} 後可領',
      LOCKED_NO_DATE: '未開放',
      DISABLED: '不可用',
    },

    hero: {
      currentLevel: '當前等級',
      rules: '規則說明',
      maxLevel: '已達最高等級',
      nextLevel: '距 V{level} 還需充值',
    },

    benefit: {
      title: '📊 等級權益表',
      hint: '共 {total} 級 · 滑動查看',
      level: '等級',
      totalDeposit: '累計充值',
      upgradeBonus: '晉級彩金',
      dailyBonus: '日俸祿',
      weeklyBonus: '周俸祿',
      monthlyBonus: '月俸祿',
    },

    rules: {
      title: 'VIP俸祿規則',
      levelAndUpgradeTitle: '等級與晉級',
      levelAndUpgrade1:
        'VIP 等級依據<b>累計有效充值</b>自動升級，<b>僅看充值金額、無打碼要求</b>，達到對應等級門檻即刻升級。',
      levelAndUpgrade2:
        '升級瞬間發放對應等級的<b>晉級彩金</b>，共 <b>50</b> 級，等級越高彩金越豐厚（V18 {amount18} / 最高 V50 {amount50}）。',
      levelAndUpgrade3: '每檔只在<b>首次達成</b>時發放一次晉級彩金，跨級升級按最高檔一次性發放。',
      retentionTitle: '保級規則',
      retention1:
        '領取日 / 周 / 月俸祿後，需在對應週期內完成<b>領取總額 10 倍</b>以上的有效打碼量方可保級。',
      retention2:
        '例：本月累計領取俸祿 {amount1}，需完成 ≥ {amount2} 有效打碼量，否則次月下降 1 級。',
      retention3:
        '<b>未領取俸祿的週期不作考核、不會降級</b> —— 不想打碼可暫不領取俸祿，等級保持不變。',
      paymentTitle: '俸祿發放',
      payment1: '<b>日俸祿</b>：每日 00:00{note} 刷新，當日手動領取，過期不補。',
      payment2: '<b>周俸祿</b>：每週一 00:00{note} 開放，本週內領取。',
      payment3: '<b>月俸祿</b>：每月 1 號 00:00{note} 開放，本月內領取。',
      payment4: '俸祿金額按當前 VIP 等級發放，升級後次日起按新等級計發。',
      claimTitle: '領取與提現',
      claim1: '所有俸祿與彩金均在「獎勵中心 · VIP俸祿」手動領取，系統不自動發放。',
      claim2: '領取的獎勵金需完成 <b>1 倍流水</b>後方可提現。',
      claim3:
        '嚴禁對沖、套利等違規行為，一經發現將取消 VIP 資格並追回獎勵。本活動最終解釋權歸平臺所有。',
    },
  },

  daily: {
    stageLabel: '第{no}關',
    claimAllPartial: '已領取 {amount}，部分關卡仍在處理中',
    claimAll: '已一鍵領取 {amount}',
    claimLevelClaimed: '已領取 {amount}',
    claimLevelProcessing: '領取處理中 {amount}',
    claimLevelChallenge: '請完成驗證',
    claimLevelPending: '領取結果待確認',
    bannerLabel: '今日可領任務獎勵',
    claimAllButton: '一鍵領取',
    claimedOutButton: '今日已領完',
    currentDeposit: '當前充值',
    currentCount: '當前進度',
    currentBet: '當前有效投注',
    nextStage: '下一關',
    completed: '已完成',
    requirementDeposit: '充值',
    requirementCount: '目標',
    requirementBet: '投注',
    typeBetTurnover: '打碼量',
    typeBetCount: '投注局數',
    typeDeposit: '充值額',
    typeLogin: '登入天數',
    typePlayGame: '試玩遊戲',
    unitRound: '局',
    unitDay: '天',
    currentOf: '當前{name}',
    statusClaimed: '✓ 已領',
    statusClaimable: '可領取',
    statusProgress: '進行中',
    statusLocked: '未解鎖',
    claimSuccessToast: '領取成功 {amount}',
  },

  acts: {
    loading: '加載中…',
    empty: '暫無活動',
    detailTitle: '活動詳情',
    todayAvailable: '今天可參與',
    waitingDays: '距活動 {days} 天',
    waitingBirthday: '距生日 {days} 天',
    remainingDays: '還需 {days} 天',
    achievedDays: '已連續 {days} 天',
    claimSuccess: '領取成功',
    claimProcessing: '發放中，請稍後查看',
    claimFailed: '領取失敗，請稍後再試',
    unsupportedResource: '暫不支持跳轉',
    birthdayTitle: '設置生日',
    birthdayHint: '生日設置成功後不可修改，請確認無誤後再提交。',
    birthdayConfirm: '確認設置',
    birthdaySet: '生日設置成功',
    status: {
      UNSET: '未設置',
      INCOMPLETE: '未完成',
      WAITING: '等待中',
      IN_PROGRESS: '進行中',
      CLAIMABLE: '可領取',
      CLAIM_PROCESSING: '發放中',
      CLAIMED: '已領取',
      EXPIRED: '已過期',
    },
    action: {
      UNSET: '確認設置',
      DEPOSIT: '去充值',
      WITHDRAW: '去提現',
      GAME: '去遊戲',
      SET_BIRTHDAY: '確認設置',
      CLAIM: '立即領取',
      OPEN_RESOURCE: '立即前往',
      AUTO: '系統自動發放中',
      NONE: '暫無',
    },
  },
}
